import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { getDetail, dataDetailReceived, setDetailPageMun } from 'datahub/actions';
import { connect } from 'react-redux';
import dataService from 'api/dataService';
import { media } from 'components/styled/utils';
import {
  Page,
  BackLink,
  TimeStamp,
  CategoriesText,
  MunicipalityCard,
  DownloadDropdown,
  Sources,
  DataBlock,
  Loading
} from 'components/layouts';
import { Container, DownloadLink, Heading, Text, RoundedButton } from 'components/styled/ui';
import { images, strings } from 'config';
import { numberTranslate } from 'utils';

class Detail extends Component {
  state = {};

  componentDidMount() {
    this.props.getDataDetail(this.props.match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data.mpc_id) {
      this.props.setDetailPageMun(nextProps.data.mpc_id);
    }
  }

  extractFileType = document => {
    const doc = document.split('.');
    return doc[doc.length - 1];
  };

  getFileName = link => {
    const linkArr = link.split('/');
    const fileName = linkArr[linkArr.length - 1].split('_');
    return fileName[fileName.length - 1];
  };

  renderDownloads(documents) {
    if (documents) {
      return (
        <ul className="download-list">
          {documents.map((link, index) => (
            <li key={index}>
              <a href={link} target="_black">
                <Text.span uppercase size={12}>
                  {this.extractFileType(link)}
                </Text.span>
                <DownloadLink>{this.getFileName(link)}</DownloadLink>
              </a>
            </li>
          ))}
        </ul>
      );
    }
  }

  renderHeader() {
    const { data } = this.props;

    return (
      <Header>
        <div className="intro">
          <Heading.h2>{data.document_title}</Heading.h2>
          {data.description && <Text>{data.description}</Text>}
          <TimeStamp className="detail-block" date={data.updated_at} />
        </div>
        <div className="action">
          <DownloadDropdown downloadAll={data.documents_all} documents={data.documents} />
        </div>
      </Header>
    );
  }

  renderIntro() {
    const { data } = this.props;

    const selectedLang = strings.getLanguage();

    return (
      <Intro lang={selectedLang}>
        <div className="detail">
          <div className="detail-content">
            <table className="table">
              <tbody>
                <tr>
                  <td>{strings.filters.documentType}</td>
                  <td>{selectedLang === 'en' ? data.document_type.en : data.document_type.ne}</td>
                </tr>
                {(data.document_source.en || data.document_source.ne) && (
                  <tr>
                    <td>{strings.filters.documentSource}</td>
                    <td>
                      {selectedLang === 'en' ? data.document_source.en : data.document_source.ne}{' '}
                      {data.document_source_other && (
                        <span className="other-source">{data.document_source_other}</span>
                      )}{' '}
                    </td>
                  </tr>
                )}

                {data.categories &&
                  data.categories.length > 0 && (
                    <tr>
                      <td>
                        {strings.filters.categories} ({strings.filters.subCategories})
                      </td>
                      <td>
                        <CategoriesText categories={data.categories} />
                      </td>
                    </tr>
                  )}

                {data.source_url &&
                  data.source_url.length > 0 && (
                    <tr>
                      <td>{strings.dataBlock.sources}(url)</td>
                      <td>
                        <Sources sources={data.source_url} />
                      </td>
                    </tr>
                  )}

                {data.published_year && (
                  <tr>
                    <td>{strings.filters.publishedDates}</td>
                    <td>{numberTranslate(data.published_year)}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="download-files">
            <Heading.h3 className="h4">{strings.detail.downloadFiles}</Heading.h3>
            {this.renderDownloads(data.documents)}

            {data.documents.length > 1 && (
              <div className="download-files__mob">
                <a href={data.documents_all}>
                  <RoundedButton>{strings.detail.downloadAll}</RoundedButton>
                </a>
              </div>
            )}
          </div>
        </div>

        <div className="mun-card">
          <MunicipalityCard
            name={data.mpc_name}
            type={data.mpc_type}
            about={data.mpc_about}
            link={data.mpc_url}
          />
        </div>
      </Intro>
    );
  }

  renderRelatedDatasets() {
    const { data } = this.props;

    if (data.related_documents.data.length) {
      return (
        <RelatedDataSets>
          <Heading.h3 className="h3">{strings.detail.relatedDataSets}</Heading.h3>

          <div>{data.related_documents.data.map((val, index) => <DataBlock data={val} />)}</div>
        </RelatedDataSets>
      );
    }
  }

  render() {
    const { fetching, data } = this.props;

    return (
      <Page>
        <Content>
          <Container>
            <Card>
              {fetching ? (
                <Loading />
              ) : (
                <Fragment>
                  <BackLink />

                  {!data.id ? (
                    <NoDataWrap>
                      <img className="icon" src={images.icons.noData} alt="No Data" />
                      <Text className="text" size={16} align="center">
                        Detail not available
                      </Text>
                    </NoDataWrap>
                  ) : (
                    <Fragment>
                      <div className="section">{this.renderHeader()}</div>
                      <div className="section">{this.renderIntro()}</div>
                      <div className="section">{this.renderRelatedDatasets()}</div>
                    </Fragment>
                  )}
                </Fragment>
              )}
            </Card>
          </Container>
        </Content>
      </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.datahub.documentDetail,
    fetching: state.datahub.fetchingDocumentDetail,
    detailPageMun: state.datahub.detailPageMun
  };
};

const mapDispatchToProps = dispatch => ({
  setDetailPageMun: munId => {
    dispatch(setDetailPageMun(munId));
  },

  getDataDetail: id => {
    dispatch(getDetail());
    dataService.getDataDetail(id).then(response => {
      dispatch(dataDetailReceived(response));
    });
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Detail);

const Card = styled.div`
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19);
  border-radius: 4px;
  padding: 18px 16px;

  ${media.sm`
     padding: 28px 42px; 
  `};
`;

const Content = styled.div`
  margin-top: 100px;

  .section {
    padding: 24px 0;

    &:not(:last-child) {
      border-bottom: 1px solid rgba(1, 73, 131, 0.12);
    }
  }

  @media screen and (min-width: 768px) {
    margin-top: 136px;
  }
`;
const Header = styled.div`

  .back-link{
    margin-bottom: 24px;
  }

  h2 {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 14px;
    line-height: 1.2;

    ${media.sm`
      font-size: 30px;
    `};
  }
  

  display: flex;
  flex-direction: column;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }

   .intro{
    flex: 1;
    margin-bottom: 12px;

    p{
      margin-bottom: 15px;
    }

  }

  .action{

    display: none;
    
    ${media.sm`
      display: block;
      margin-left: 30px;
   `};
   
`;
const Intro = styled.div`
  display: flex;
  flex-direction: column;

  h3 {
    margin-bottom: 24px;
  }

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }

  .detail {
    flex: 1;

    .detail-content {
      padding: 0 0 24px 0;
      border-bottom: 1px solid rgba(1, 73, 131, 0.12);

      .table {
        background-color: rgba(235, 235, 235, 0.24);
        border: 1px solid rgb(235, 235, 235);
        border-radius: 4px;
        width: 100%;
        tbody {
          tr {
            &:not(:last-child) {
              border-bottom: 1px solid rgba(1, 73, 131, 0.07);
            }

            td {
              padding: 16px 24px;
              line-height: 1.36;

              font-size: ${props => (props.lang === 'en' ? '14px' : '16px')};
              color: #4a4a4a;

              &:first-child {
                color: rgba(115, 123, 129, 0.78);
                width: 24%;
                @media screen and (max-width: 600px) {
                  width: 100%;
                  padding-bottom: 0;
                }
              }

              @media screen and (max-width: 600px) {
                display: block;
              }

              .other-source {
                &:before {
                  content: '(';
                }
                &:after {
                  content: ')';
                }
              }
            }
          }
        }
      }

      p {
        margin-bottom: 24px;
      }
    }

    .download-files {
      padding: 24px 0 24px 0;

      &__mob {
        ${media.sm`
          display: none;
        `};
      }

      @media screen and (max-width: 768px) {
        border-bottom: 1px solid rgba(1, 73, 131, 0.12);
        margin-bottom: 24px;
      }

      .download-list {
        margin-bottom: 24px;
        > li {
          &:not(:last-child) {
            margin-bottom: 12px;
          }

          span {
            background-color: #ebebeb;
            padding: 4px 12px;
            border-radius: 12px;
            display: inline-block;
            margin-right: 10px;
            float: left;
          }
        }
      }
    }
  }

  .mun-card {
    width: 260px;
    @media screen and (min-width: 768px) {
      margin-left: 30px;
    }
  }
`;
const RelatedDataSets = styled.div`
  h3 {
    margin-bottom: 24px;
  }
`;

const NoDataWrap = styled.div`
  text-align: center;
  .icon {
    margin-bottom: 8px;
  }
  .text {
    color: #adadad;
    margin-bottom: 24px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/detail/detail.js